import { useMemo } from 'react';
import { DatePicker, DatePickerProps } from '@material-ui/pickers';

import { useForm } from '../hooks';

import FormDateTextField from './FormDateTextField';
import { get as _get } from 'lodash';

export interface FormDateProps extends Partial<DatePickerProps> {
	id: string;
	description: string;
}

const FormDate: React.FC<FormDateProps> = ({ id, description, ...rest }) => {
	const form = useForm();

	const value = _get(form.values, id);

	const handleDateChange = (date: Date | null) => {
		form.setFieldValue(id, date);
	}

	return (
		<DatePicker
			format="dd/MM/yyyy"
			views={["year", "month", "date"]}
			value={value}
			onChange={handleDateChange}
			InputProps={{ id, name: description }}
			TextFieldComponent={FormDateTextField}
			{...rest}
		/>
	);
}

export default FormDate;